import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomBarcode({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="currentColor" fillRule="nonzero">
        <path d="M.484 5.52H.16A.16.16 0 010 5.36v-3.2A.16.16 0 01.161 2h3.226a.16.16 0 01.161.16v.32a.16.16 0 01-.16.16H.805a.16.16 0 00-.16.16v2.56a.16.16 0 01-.162.16zM3.387 18H.161A.16.16 0 010 17.84v-3.2a.16.16 0 01.161-.16h.323a.16.16 0 01.161.16v2.56c0 .088.072.16.161.16h2.581a.16.16 0 01.161.16v.32a.16.16 0 01-.16.16zM19.839 18h-3.226a.16.16 0 01-.161-.16v-.32a.16.16 0 01.16-.16h2.582a.16.16 0 00.16-.16v-2.56a.16.16 0 01.162-.16h.323a.16.16 0 01.161.16v3.2a.16.16 0 01-.161.16zM19.839 5.52h-.323a.16.16 0 01-.161-.16V2.8a.16.16 0 00-.161-.16h-2.581a.16.16 0 01-.161-.16v-.32a.16.16 0 01.16-.16h3.227a.16.16 0 01.161.16v3.2a.16.16 0 01-.161.16z" />
        <g>
          <path d="M3 4.8h.875v10.577H3zM13.719 4.8h.437v10.577h-.437zM5.844 4.8h.437v10.577h-.437zM11.75 4.8h.875v10.577h-.875zM4.75 4.8h.875v10.577H4.75zM8.469 4.8h.437v10.577H8.47zM7.375 4.8h.875v10.577h-.875zM16.344 4.8h.437v10.577h-.437zM15.25 4.8h.875v10.577h-.875zM9.344 4.8h.437v10.577h-.437zM10 4.8h.875v10.577H10z" />
        </g>
      </g>
    </svg>
  );
}
export default SvgIconCustomBarcode;
